module.exports = __webpack_public_path__ + "images/no-events-c61f292f.svg";